import { BrowserRouter, Route, Routes } from "react-router-dom";

import "./assets/base.scss";

import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import PLTranslations from "./i18n/pl-PL.json";
import GBTranslations from "./i18n/en-GB.json";
import DETranslations from "./i18n/de-DE.json";
import BGTranslations from "./i18n/bg-BG.json";
import CZTranslations from "./i18n/cs-CZ.json";
import DKTranslations from "./i18n/da-DK.json";
import GRTranslations from "./i18n/el-GR.json";
import ESTranslations from "./i18n/es-ES.json";
import EETranslations from "./i18n/et-EE.json";
import FITranslations from "./i18n/fi-FI.json";
import FRTranslations from "./i18n/fr-FR.json";
import IETranslations from "./i18n/ga-IE.json";
import HRTranslations from "./i18n/hr-HR.json";
import HUTranslations from "./i18n/hu-HU.json";
import ITTranslations from "./i18n/it-IT.json";
import LTTranslations from "./i18n/lt-LT.json";
import LVTranslations from "./i18n/lv-LV.json";
import MTTranslations from "./i18n/mt-MT.json";
import NLTranslations from "./i18n/nl-NL.json";
import PTTranslations from "./i18n/pt-PT.json";
import ROTranslations from "./i18n/ro-RO.json";
import SKTranslations from "./i18n/sk-SK.json";
import SITranslations from "./i18n/sl-SI.json";
import SVTranslations from "./i18n/sv-SE.json";

import { ErrorBoundary } from "@sentry/react";
import ConfirmationPage from "./pages/ConfirmationPage";
import SelectionPage from "./pages/PaymentSelectionPage";
import BlikPage from "./pages/BlikPaymentPage";
import MainPage from "./pages/MainPage";
import { useEffect, useState } from "react";
import { DEFAULT_LANGUAGE } from "./Constants";

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      "pl-PL": { translation: PLTranslations },
      "en-GB": { translation: GBTranslations },
      "de-DE": { translation: DETranslations },
      "bg-BG": { translation: BGTranslations },
      "cs-CZ": { translation: CZTranslations },
      "da-DK": { translation: DKTranslations },
      "el-GR": { translation: GRTranslations },
      "es-ES": { translation: ESTranslations },
      "et-EE": { translation: EETranslations },
      "fi-FI": { translation: FITranslations },
      "fr-FR": { translation: FRTranslations },
      "ga-IE": { translation: IETranslations },
      "hr-HR": { translation: HRTranslations },
      "hu-HU": { translation: HUTranslations },
      "it-IT": { translation: ITTranslations },
      "lt-LT": { translation: LTTranslations },
      "lv-LV": { translation: LVTranslations },
      "mt-MT": { translation: MTTranslations },
      "nl-NL": { translation: NLTranslations },
      "pt-PT": { translation: PTTranslations },
      "ro-RO": { translation: ROTranslations },
      "sk-SK": { translation: SKTranslations },
      "sl-SI": { translation: SITranslations },
      "sv-SE": { translation: SVTranslations },
    },
    // Set the default language to Polish
    lng: DEFAULT_LANGUAGE,
    // Disable i18next's default escaping, which prevents XSS
    // attacks. React already takes care of this.
    interpolation: {
      escapeValue: false,
    },
  });

function App() {
  const [iframe, setIframe] = useState(false);

  useEffect(() => {
    if (window.top !== window) {
      try {
        window.top.location.href = window.location.href;
      } catch (e) {}
      setIframe(true);
    }
  }, []);

  if (iframe)
    return (
      <h3 className='text-center'>
        Alerm bezpieczeństwa.
        <br /> Wykryto próbę otworzenia strony w elemencie IFrame.
      </h3>
    );

  return (
    <div className='App'>
      <ErrorBoundary fallback={<p>An error has occurred</p>}>
        <BrowserRouter>
          <Routes>
            <Route exact path='/' Component={MainPage} />
            <Route path='/confirm/:transactionId' Component={ConfirmationPage} />
            <Route path='/payment/:transactionId' Component={SelectionPage} />
            <Route path='/blik/:transactionId' Component={BlikPage} />
          </Routes>
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
